import * as React from "react";
import { RankingConstants } from "../../constants/RankingConstants";
import { IdStyles } from "../../less/IdStyles";
import { getMedalByIdLeagues, noIdLeaguesToMedals } from "./mapIdLeaguesToMedals";
import { PlayerProfileMedal } from "./PlayerProfileMedal";
export var PlayerProfileAwardsArea = React.memo(function (_a) {
    var coopLeagueCupIndex = _a.coopLeagueCupIndex, playerLeagueCupIndex = _a.playerLeagueCupIndex, playerLeagueStars = _a.playerLeagueStars, coopLeagueStars = _a.coopLeagueStars;
    var getCupOrEmpty = function (index, numberOfDivisions) {
        return index !== undefined && index >= 0
            ? getMedalByIdLeagues((index - 1) / numberOfDivisions)
            : noIdLeaguesToMedals;
    };
    var coopLeagueCup = getCupOrEmpty(coopLeagueCupIndex, RankingConstants.NumberCoopDivisions)
        .coopLeagueMedal;
    var playerLeagueCup = getCupOrEmpty(playerLeagueCupIndex, RankingConstants.NumberPlayerLeagueDivisions).playerLeagueMedal;
    return (React.createElement("div", { className: IdStyles.PlayerProfileLeagueBackground + " flex" },
        React.createElement(PlayerProfileMedal, { cupType: playerLeagueCup, difficultyLevel: playerLeagueStars, maxDifficulty: RankingConstants.NumberPlayerLeagueDivisions }),
        React.createElement(PlayerProfileMedal, { cupType: coopLeagueCup, difficultyLevel: coopLeagueStars, maxDifficulty: RankingConstants.NumberCoopDivisions })));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/PlayerProfileAwardsArea.tsx
// module id = 2872
// module chunks = 3